import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { formatDate } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DeviceIdService } from './device-id.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  http = inject(HttpClient);
  private deviceService = inject(DeviceDetectorService);
  private deviceIdService = inject(DeviceIdService);
  private router = inject(Router);
  private snackbar = inject(MatSnackBar);

  private errorData: { errorDesc: string; errorTitle: string };
  public pdasUserData: null;

  deviceInformation = {
    platform: '',
    osVersion: '',
    deviceId: '',
    appVersion: '',
    deviceName: '',
    appType: 'Delivery',
    userAgent: '',
    browser: '',
    orientation: '',
  };

  // pickup locations.
  selectedLocation = new Subject<any>();

  // drop location
  dropoffLocation = new Subject<any>();

  // dropoff close without select any location.
  dropoffCloseWithoutData = new Subject<boolean>();

  constructor() {
    console.log('deviceService', this.deviceService.getDeviceInfo());

    const deviceInfo = this.deviceService.getDeviceInfo();
    this.deviceInformation.platform = 'Web';
    this.deviceInformation.osVersion = deviceInfo?.os_version;
    this.deviceInformation.deviceId = this.deviceIdService.getDeviceId();
    this.deviceInformation.appVersion = deviceInfo?.browser_version;
    this.deviceInformation.deviceName = deviceInfo?.deviceType;
    this.deviceInformation.userAgent = deviceInfo?.userAgent;
    this.deviceInformation.browser = deviceInfo?.browser;
    this.deviceInformation.orientation = deviceInfo?.orientation;
  }

  getToken() {
    return localStorage.getItem('PWAToken');
  }

  emitData(data: any): void {
    this.selectedLocation.next(data);
  }

  emitDropoffData(data: any): void {
    this.dropoffLocation.next(data);
  }

  emitdropoffCloseWithoutData(data: boolean): void {
    this.dropoffCloseWithoutData.next(data);
  }

  // emitDropoffIndex(data:any):void{
  //     this.dropoffIndex.emit(data);
  // }

  /* 
        YYYY-MM-DD hh:mm A 
    */
  public dateFormate(date) {
    // return date.toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true});
    return formatDate(date, 'yyyy-MM-dd hh:mm a', 'en-US');
  }

  public getData<T>(url: string) {
    return this.http.get(url).pipe(catchError(this.handleError));
  }

  public getDataWithHeader<T>(url: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-access-token': this.getToken(),
        platform: 'Web',
        ...this.deviceInformation,
      }),
    };
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  public getDataWithoutHeader<T>(url: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        platform: 'Web',
        ...this.deviceInformation,
      }),
    };
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  public postDataWithHeader<T>(url: string, toAdd: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        //  'content-type':'multipart/form-data',
        'x-access-token': this.getToken(),
        platform: 'Web',
        ...this.deviceInformation,
      }),
    };
    return this.http
      .post(url, toAdd, httpOptions)
      .pipe(catchError(this.handleError));
  }

  public postDataWithHeaderFormData<T>(url: string, toAdd: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'x-access-token': this.getToken(),
        ...this.deviceInformation,
      }),
    };
    return this.http
      .post(url, toAdd, httpOptions)
      .pipe(catchError(this.handleError));
  }

  public putDataWithHeader<T>(url: string, toAdd: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'x-access-token': this.getToken(),
        platform: 'Web',
        ...this.deviceInformation,
      }),
    };
    return this.http
      .put(url, toAdd, httpOptions)
      .pipe(catchError(this.handleError));
  }

  public deleteDataWithHeader<T>(url: string, toAdd: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'x-access-token': this.getToken(),
        platform: 'Web',
        ...this.deviceInformation,
      }),
      body: toAdd,
    };
    return this.http
      .delete(url, httpOptions)
      .pipe(catchError(this.handleError));
  }

  public postDataWithoutHeader<T>(url: string, toAdd: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        appType: 'Delivery',
        lanuguage: 'en',
        ...this.deviceInformation,
      }),
    };
    return this.http
      .post(url, toAdd, httpOptions)
      .pipe(catchError(this.handleError));
  }

  public postData<T>(url: string, toAdd: any) {
    return this.http.post(url, toAdd).pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse) => {
    if (error?.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      // Avoid relying on class context here; just log and return normalized error
      if (error?.status === 401) {
        try {
          localStorage.removeItem('PWAToken');
          localStorage.removeItem('country');
          localStorage.removeItem('authUser');
        } catch (_) {}
      }
      const body =
        typeof error?.error === 'string'
          ? error.error
          : JSON.stringify(error?.error);
      console.error(
        `Backend returned code ${error?.status}, body was: ${body}`
      );
    }

    const normalizedError = {
      errorTitle: 'Oops! Request for document failed',
      errorDesc: 'Something bad happened. Please try again later.',
    };
    return throwError(() => normalizedError);
  };
}
